import {LocaleDictionaryCalendar} from "../../interface/calendar";

export const calendar: LocaleDictionaryCalendar = {
    today : 'Сегодня',
    title : 'Календарь',
    weekDays : ['Пн', 'Вт', 'Ср', 'Чт' , 'Пт', 'Сб', 'Вс']
};



